import { ReactNode } from "react";

import { WasteStepperContext, WasteStepperContextValue } from "./WasteStepperContextValue";

export function WasteStepperProvider({
  value,
  children,
}: {
  value: WasteStepperContextValue;
  children: ReactNode;
}) {
  return <WasteStepperContext.Provider value={value}>{children}</WasteStepperContext.Provider>;
}
